import React, { useState, useEffect } from "react";
import { Alert } from "antd";


export const AlertasGenerales = ({inAlerta}) => {
    const [alerta, setAlerta] = useState(inAlerta || null);
    
    useEffect(() => {
        // Actualizar el estado local cuando cambia la prop inAlerta
        if (inAlerta) {
          setAlerta(inAlerta);
        }
      }, [inAlerta]);
    
      useEffect(() => {
        // Cerrar la alerta después de 5 segundos si existe
        if (alerta) {
          const timer = setTimeout(() => setAlerta(null), 5000); // Cierra después de 5 segundos
          return () => clearTimeout(timer); // Limpia el temporizador si el componente se desmonta
        }
      }, [alerta]);
  return (
    alerta && (
        <div
          style={{
            position: "fixed",
            bottom: 20,
            left: 20,
            zIndex: 1000,
          }}
        >
          <Alert
            message={alerta.message}
            type={alerta.type}
            showIcon
            closable
            onClose={() => setAlerta(null)} 
          />
        </div>
    )
  );
};
